import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({
  children,
  adminOnly = false,
  candidateOnly = false,
  redirectMessageKey,
}) => {
  const { isAuthenticated, isAdmin, isCandidate, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
          message: redirectMessageKey ? t(redirectMessageKey) : undefined,
        }}
      />
    );
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (candidateOnly && !isCandidate()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
